<template>
  <b-container>
    <b-row class="pb-3">
      <b-col>
        <span class="cs-footer-links-title">{{ content.title }}</span>
      </b-col>
    </b-row>
    <b-row v-for="(link) in content.links" v-bind:key="link._id">
      <b-col>
        <b-link class="cs-footer-links-link" :to="link.link">
          {{ link.name }}
        </b-link>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Links',
  props: {
    content: Object,
  },
};
</script>

<style scoped lang="scss">
.cs-footer-links-title {
  color: $brandPrimaryColor;
  font-size: $footerItemsTitle;
  font-weight: bold;
}

.cs-footer-links-link {
  color: $footerPrimaryColor;
  &:hover {
    color: $brandPrimaryColor;
  }
}
</style>
